import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FetchStatus, ModalName } from '../../../../enums';
import { useCloseModal, useModalProps } from '../../../../features/modals';
import {
  useDeleteOrganizationUser,
  useOrganization,
  useResetDeleteOrganizationUserStatus,
} from '../../../../features/organization';
import { Button, Modal } from '../../../common';
import { IDeleteUserModalProps } from './types';

export const DeleteUserModal = () => {
  const { t } = useTranslation();
  const {
    status: { deleteUser: status },
  } = useOrganization();
  const deleteOrganizationUser = useDeleteOrganizationUser();
  const resetDeleteOrganizationUserStatus = useResetDeleteOrganizationUserStatus();
  const { user } = useModalProps(ModalName.DELETE_USER) as IDeleteUserModalProps;
  const closeModal = useCloseModal(ModalName.DELETE_USER);

  const remove = useCallback(() => {
    deleteOrganizationUser(user);
  }, [deleteOrganizationUser, user]);

  useEffect(() => {
    if (status === FetchStatus.SUCCESS) {
      closeModal();
      resetDeleteOrganizationUserStatus();
    }
  }, [status]);

  const footer: JSX.Element = useMemo(() => {
    return (
      <div className="flex">
        <Button
          text={t('modal.deleteUser.button.delete')}
          loading={status === FetchStatus.LOADING}
          type="destructive"
          onClick={remove}
        />
        <Button text={t('modal.deleteUser.button.cancel')} type="tertiary" onClick={closeModal} className="ml-2" />
      </div>
    );
  }, [closeModal, remove, status]);

  return (
    <Modal name={ModalName.DELETE_USER} header={t('modal.deleteUser.title')} footer={footer}>
      <span className="typography-paragraph-3 text-text-secondary whitespace-pre-line">
        {t('modal.deleteUser.description')}
      </span>
    </Modal>
  );
};
